import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [^\s]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload(); // Reloads and gets the latest chunks
    } else {
      throw error;
    }
  }
}